module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "bookings"
    }
  }, [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body",
      "id": "booking-details"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n            " + _vm._s(err[0]) + "\n          ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n            " + _vm._s(_vm.error) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(" " + _vm._s(_vm.$t("booking.detail.back_to_list")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticClass: "user"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.guest.first_name) + "   " + _vm._s(_vm.guest.last_name))]), _vm._v(" "), (_vm.booking && _vm.booking.checking && _vm.booking.checkout) ? _c('span', {
    staticClass: "nb-nights after-pannel-title"
  }, [_c('i', {
    staticClass: "icon-rental-moon"
  }), _vm._v(_vm._s(_vm._f("calculateNight")(_vm.booking.checking, _vm.booking.checkout)))]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('span', {
    staticClass: "nb-pers after-pannel-title"
  }, [_c('i', {
    staticClass: "icon-rental-user"
  }), _vm._v(" " + _vm._s(parseInt(_vm.booking.nbr_adults) + parseInt(_vm.booking.nbr_children)) + " " + _vm._s(_vm.$t("booking.detail.persons")))]) : _vm._e(), _vm._v(" "), (_vm.booking && _vm.booking.checking && _vm.booking.checkout) ? _c('span', {
    staticClass: "plage-date after-pannel-title"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("formatShortDate")(_vm.booking.checking)) + " - " + _vm._s(_vm._f("formatShortDate")(_vm.booking.checkout)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'informations'),
      expression: "activeTab == 'informations'"
    }],
    staticClass: "btn_area"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("button.actions")) + "\n                          "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        !_vm.booking.id ? _vm.save_booking(_vm.booking, _vm.guest) : _vm.pre_edit_booking(_vm.booking, _vm.guest, _vm.inputs)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])]), _vm._v(" "), (_vm.booking.id) ? _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.duplicateBooking(_vm.booking, _vm.guest)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.duplicate")))])]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delete_booking(_vm.booking.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.delete")))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'invoices'),
      expression: "activeTab == 'invoices'"
    }],
    staticClass: "invoices"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("button.actions")) + "\n                          "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save_invoices(_vm.invoices)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": '#/invoice/' + _vm.booking.permalink + '/edit'
    }
  }, [_vm._v(_vm._s(_vm.$t('button.preview_and_edit')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.open_send_invoice_modal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send_invioce')))])]), _vm._v(" "), _c('li', {
    staticClass: "btn8",
    attrs: {
      "data-clipboard-text": _vm.location.protocol + '//' + 'superhote.com' + '/applink/invoice/' + _vm.booking.permalink
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("button.copy_a_link")))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'contract'),
      expression: "activeTab == 'contract'"
    }],
    staticClass: "invoices"
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("button.actions")) + "\n                          "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": '#/booking/' + _vm.booking.permalink + '/contract'
    },
    on: {
      "click": function($event) {
        _vm.preview_booking_contract(_vm.booking)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.view_contract')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.open_send_contract_modal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send_contract")))])]), _vm._v(" "), _c('li', {
    staticClass: "btn9",
    attrs: {
      "data-clipboard-text": _vm.location.protocol + '//' + 'superhote.com' + '/applink/booking/' + _vm.booking.permalink + '/contract'
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t("button.copy_a_link")))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'payments'),
      expression: "activeTab == 'payments'"
    }]
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("button.actions")) + "\n                            "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.makePayment(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.make_payment')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.makePayment(0)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.make_deposit')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.newPayment(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.new_payment')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.newPayment(0)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.new_deposit')) + " ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createGlobalPayment()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('button.create_global_payment')) + " ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'events'),
      expression: "activeTab == 'events'"
    }]
  }, [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-red btn-bold waves-effect waves-classic btn-with-caret ",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("button.actions")) + "\n                            "), _c('span', {
    staticClass: "dropdown-toggle"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "booking-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    class: _vm.activeTab == 'informations' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('informations')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.informations.title')))]), _vm._v(" "), (_vm.booking.id) ? _c('li', {
    class: _vm.activeTab == 'messages' ? 'active' : '',
    attrs: {
      "id": "messages-tab"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('messages')
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('booking.detail.messages.title')))]), _vm._v(" "), (_vm.unreadLength(_vm.messages) > 0) ? _c('span', {
    staticClass: "badge badge-pill badge-warning up badge_add"
  }, [_vm._v(_vm._s(_vm.unreadLength(_vm.messages)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.booking.id && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.rights && _vm.showBookingActions))) ? _c('li', {
    class: _vm.activeTab == 'payments' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('payments')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.payments.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.rights && _vm.showBookingActions))) ? _c('li', {
    class: _vm.activeTab == 'contract' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('contract')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.contract.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.rights && _vm.showBookingActions))) ? _c('li', {
    class: _vm.activeTab == 'invoices' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('invoices')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('li', {
    class: _vm.activeTab == 'events' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('events')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('li', {
    class: _vm.activeTab == 'forms' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('forms')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.forms.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('li', {
    class: _vm.activeTab == 'resources' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('resources')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.resources.title')))]) : _vm._e(), _vm._v(" "), (_vm.booking.id) ? _c('li', {
    class: _vm.activeTab == 'event-logger' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('event-logger')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("logs.tab")))]) : _vm._e()])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "message-page"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'informations'),
      expression: "activeTab == 'informations'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    attrs: {
      "id": "booking-details-form",
      "method": "post",
      "role": "form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        !_vm.booking.id ? _vm.save_booking(_vm.booking, _vm.guest) : _vm.edit_booking(_vm.booking, _vm.guest)
      }
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.guest_details")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "first-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.first_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.first_name),
      expression: "guest.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "last-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.last_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.last_name),
      expression: "guest.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "last_name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.email),
      expression: "guest.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.alternative_email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.alternative_email),
      expression: "guest.alternative_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "alternativeEmail",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.alternative_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "alternative_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.guest.airbnb_email != null) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb_email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.airbnb_email),
      expression: "guest.airbnb_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "airbnb_email",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.guest.airbnb_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "airbnb_email", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.phone")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.phone),
      expression: "guest.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "phone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "alternative-phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.alternative_phone")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.alternative_phone),
      expression: "guest.alternative_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "alternative-phone",
      "required": ""
    },
    domProps: {
      "value": (_vm.guest.alternative_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "alternative_phone", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.zip_code")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.zip_code),
      expression: "guest.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "zip_code"
    },
    domProps: {
      "value": (_vm.guest.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "zip_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.address")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.address),
      expression: "guest.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "address"
    },
    domProps: {
      "value": (_vm.guest.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "address", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.city")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.city),
      expression: "guest.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "city"
    },
    domProps: {
      "value": (_vm.guest.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.guest, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-country"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.country")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guest.country),
      expression: "guest.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "settings-country",
      "id": "settings-country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.guest, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.code
      }
    }, [_vm._v(_vm._s(country.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cleaning_fee"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.cleaning_fees")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cleaningFee),
      expression: "cleaningFee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cleaning_fee"
    },
    domProps: {
      "value": (_vm.cleaningFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cleaningFee = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "city_taxes_fee"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.city_taxes")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityTaxes),
      expression: "cityTaxes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "city_taxes_fee"
    },
    domProps: {
      "value": (_vm.cityTaxes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityTaxes = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "service_charges"
    }
  }, [_vm._v("Frais de service")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.service_charges),
      expression: "booking.service_charges"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "service_charges"
    },
    domProps: {
      "value": (_vm.booking.service_charges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "service_charges", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "other_charges"
    }
  }, [_vm._v("Autres frais")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.other_charges),
      expression: "booking.other_charges"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "other_charges"
    },
    domProps: {
      "value": (_vm.booking.other_charges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "other_charges", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "commission"
    }
  }, [_vm._v("Commission")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.commission),
      expression: "booking.commission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "commission"
    },
    domProps: {
      "value": (_vm.booking.commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "commission", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "payment_charges"
    }
  }, [_vm._v("Frais de paiement")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.payment_charges),
      expression: "booking.payment_charges"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "payment_charges"
    },
    domProps: {
      "value": (_vm.booking.payment_charges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "payment_charges", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.detail_section")) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "apartment"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.apartment")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [(_vm.booking.channel_id === 1 || _vm.booking.channel_id === 2) ? _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('booking.index.modification_disabled_info')
    }
  }) : _vm._e()]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.rental_id),
      expression: "booking.rental_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.booking.channel_id === 1 || _vm.booking.channel_id === 2,
      "id": "apartment"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "rental_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getNotAvailableDatesAndCalculatePrice(_vm.checkinDate, _vm.checkoutDate)
      }]
    }
  }, _vm._l((_vm.rentals), function(rental) {
    return _c('option', {
      domProps: {
        "value": rental.id
      }
    }, [_vm._v(_vm._s(rental.name))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.status")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.status),
      expression: "booking.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.bookingStatuses), function(index, statusName) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(_vm.$t(("booking.detail.status." + statusName))))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "check-in"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.check_in")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [(_vm.booking.channel_id === 1 || _vm.booking.channel_id === 2) ? _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('booking.index.modification_disabled_info')
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.booking.channel_id !== 1 && _vm.booking.channel_id !== 2) ? _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "id": "check-in",
      "language": _vm.language === 'fr' ? _vm.fr : _vm.en,
      "format": "D dd MMMM yyyy",
      "highlighted": _vm.stateChecking.highlighted
    },
    model: {
      value: (_vm.checkinDate),
      callback: function($$v) {
        _vm.checkinDate = $$v
      },
      expression: "checkinDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.booking.channel_id === 1 || _vm.booking.channel_id === 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkinDateFormated),
      expression: "checkinDateFormated"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.checkinDateFormated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkinDateFormated = $event.target.value
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "arrival-time"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.arrival_time")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.time_in),
      expression: "booking.time_in"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "arrival-time"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "time_in", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(i) {
    return _c('option', {
      domProps: {
        "value": i < 10 ? '0' + i : i
      }
    }, [_vm._v(_vm._s(i < 10 ? '0' + i : i))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "check-out"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.check_out")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [(_vm.booking.channel_id === 1 || _vm.booking.channel_id === 2) ? _c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('booking.index.modification_disabled_info')
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.booking.channel_id !== 1 && _vm.booking.channel_id !== 2) ? _c('datepicker', {
    staticClass: "form-control",
    attrs: {
      "id": "check-out",
      "language": _vm.language === 'fr' ? _vm.fr : _vm.en,
      "format": "D dd MMMM yyyy",
      "highlighted": _vm.stateCheckout.highlighted
    },
    model: {
      value: (_vm.checkoutDate),
      callback: function($$v) {
        _vm.checkoutDate = $$v
      },
      expression: "checkoutDate"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.booking.channel_id === 1 || _vm.booking.channel_id === 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkoutDateFormated),
      expression: "checkoutDateFormated"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.checkoutDateFormated)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkoutDateFormated = $event.target.value
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "departure-time"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.departure_time")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.time_out),
      expression: "booking.time_out"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "departure-time"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "time_out", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.hours), function(i) {
    return _c('option', {
      domProps: {
        "value": i < 10 ? '0' + i : i
      }
    }, [_vm._v(_vm._s(i < 10 ? '0' + i : i))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nb-adults"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.number_of_adults")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.nbr_adults),
      expression: "booking.nbr_adults"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nb-adults",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.nbr_adults)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "nbr_adults", $event.target.value)
      }, function($event) {
        _vm.calculateBookingPrice(_vm.checkinDate, _vm.checkoutDate, _vm.booking.nbr_adults, _vm.booking.nbr_children)
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "nb-children"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.number_of_children")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.nbr_children),
      expression: "booking.nbr_children"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "nb-children",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.nbr_children)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "nbr_children", $event.target.value)
      }, function($event) {
        _vm.calculateBookingPrice(_vm.checkinDate, _vm.checkoutDate, _vm.booking.nbr_adults, _vm.booking.nbr_children)
      }]
    }
  })])])]), _vm._v(" "), (_vm.$route.name == 'bookings.details.tab' || _vm.activeTab === 'informations') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Payment")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_status),
      expression: "payment_status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "payment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.payment_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 12
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("KO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Deposit")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deposit_status),
      expression: "deposit_status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "deposit"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.deposit_status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 14
    }
  }, [_vm._v("KO")])])])])]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'bookings.create' || _vm.activeTab === 'informations') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.priceCalculationLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceCalculationLoading),
      expression: "!priceCalculationLoading"
    }],
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-price"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.price_nights")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.price),
      expression: "booking.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "booking-price",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.price)
    },
    on: {
      "change": function($event) {
        _vm.setTaxes(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "price", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "follow-up-option"
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.to_throw_back')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.follow_up),
      expression: "booking.follow_up"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "follow-up-option"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "follow_up", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.yes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.no')))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('div', {
    staticClass: "col-6"
  }, [(_vm.booking.promo_amount) ? _c('p', [_vm._v(_vm._s(_vm.$t('booking.promo.promo_discount')) + " -\n                              "), _c('span', [_vm._v(_vm._s(_vm.booking.promo_amount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.promo_type === 'fixed' ? _vm.currency : '%'))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "customize-color"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary float-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.enable_booking_color),
      expression: "booking.enable_booking_color"
    }],
    attrs: {
      "type": "checkbox",
      "id": "enable-custom-color"
    },
    domProps: {
      "checked": Array.isArray(_vm.booking.enable_booking_color) ? _vm._i(_vm.booking.enable_booking_color, null) > -1 : (_vm.booking.enable_booking_color)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.booking.enable_booking_color,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.booking, "enable_booking_color", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.booking, "enable_booking_color", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.booking, "enable_booking_color", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "enable-custom-color"
    }
  }, [_vm._v(_vm._s(_vm.$t('automation.index.modal.custom_color')))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-25"
  }, [_c('color-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.booking.enable_booking_color),
      expression: "booking.enable_booking_color"
    }],
    staticClass: "mb-0",
    attrs: {
      "color": _vm.booking.booking_color,
      "name": false,
      "enableColor": _vm.booking.enable_booking_color
    },
    on: {
      "updateCurrentColor": _vm.updateCurrentColor
    },
    model: {
      value: (_vm.booking.booking_color),
      callback: function($$v) {
        _vm.$set(_vm.booking, "booking_color", $$v)
      },
      expression: "booking.booking_color"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.$route.name.includes('bookings.details') && _vm.activeTab === 'informations') ? _c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-amount-remaining"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.amount_remaining")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.amount_remaining),
      expression: "booking.amount_remaining"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background-color": "#eee"
    },
    attrs: {
      "type": "text",
      "id": "booking-amount-remaining",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.booking.amount_remaining)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "amount_remaining", $event.target.value)
      }
    }
  })])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner",
    attrs: {
      "id": "platform_notes_container"
    }
  }, [_c('div', [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.platforms.title")) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "source"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.source")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.channel_id),
      expression: "booking.channel_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "source",
      "disabled": _vm.booking.channel && _vm.booking.channel.name === 'Ical'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.booking, "channel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.channels), function(channel) {
    return _c('option', {
      attrs: {
        "disabled": channel && channel.name === 'Ical'
      },
      domProps: {
        "value": channel.id
      }
    }, [_vm._v("\n                                    " + _vm._s(channel.name) + "\n                                  ")])
  }))])])]), _vm._v(" "), (_vm.booking.channel_id == 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "confirmation-code"
    }
  }, [_vm._v(_vm._s(_vm.$t('calendar.booking-detail.confirmation_code')))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.confirmation_code),
      expression: "booking.confirmation_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "confirmation-code",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.confirmation_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "confirmation_code", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), (_vm.user.plan_id === 4 && _vm.booking.channel_id === 2 && _vm.booking.booking_com_res_id) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reportInvalidCard()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.report_card_invalid')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 p-l-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelReportInvalidCard()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.report_cancellation_invalid_card')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.bookingUrl) ? _c('div', {
    staticClass: "m-b-10"
  }, [_c('a', {
    attrs: {
      "href": _vm.bookingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.booking_page')))])]) : _vm._e(), _vm._v(" "), (_vm.booking.codes && _vm.booking.codes[0]) ? _c('div', [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.door_code.title")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "door-code"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.door_code.code_label')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.codes[0].code),
      expression: "booking.codes[0].code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "door-code"
    },
    domProps: {
      "value": (_vm.booking.codes[0].code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking.codes[0], "code", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.regenerateDoorCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.door_code.generate_code_label')))])])])])]) : _vm._e(), _vm._v(" "), (_vm.user.plan_id === 4 && _vm.booking.reservation_details) ? _c('div', [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.detail_section')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookingResDetails),
      expression: "bookingResDetails"
    }],
    staticClass: "form-control my-10",
    attrs: {
      "id": "reservation-details",
      "cols": "100",
      "rows": "6",
      "data-component": "textarea",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.bookingResDetails)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookingResDetails = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.form.fields && _vm.form.fields.length > 0) ? _c('div', [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.notes')))]), _vm._v(" "), _vm._l((_vm.form.fields), function(field, index) {
    return _c('div', [(field.type.name == 'input' && field.element.name == 'text') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                    " + _vm._s(field.label) + "\n                                    "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]),
        expression: "inputs[field.model]"
      }],
      staticClass: "form-control border-0",
      attrs: {
        "id": field.type.name + index,
        "type": "text",
        "required": field.mandatory == 1
      },
      domProps: {
        "value": (_vm.inputs[field.model])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.inputs, field.model, $event.target.value)
        }
      }
    })])])]) : _vm._e(), _vm._v(" "), (field.type.name == 'textarea') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                " + _vm._s(field.label) + "\n                                "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]),
        expression: "inputs[field.model]"
      }],
      staticClass: "form-control my-10",
      attrs: {
        "id": field.label + index,
        "name": "",
        "cols": "100",
        "rows": "6",
        "data-component": "textarea"
      },
      domProps: {
        "value": (_vm.inputs[field.model])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.inputs, field.model, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (field.type.name == 'select') ? _c('div', {
      staticClass: "row form-group form-material"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": field.type.name + index
      }
    }, [_vm._v("\n                                    " + _vm._s(field.label) + "\n                                    "), (field.mandatory == 1) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.inputs[field.model]),
        expression: "inputs[field.model]"
      }],
      staticClass: "select form-control",
      attrs: {
        "id": "field.type.name + index"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.inputs, field.model, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('input.please_select')) + " ")]), _vm._v(" "), _vm._l((field.select_options), function(option, i) {
      return _c('option', {
        attrs: {
          "id": field.type.name + i,
          "type": field.element.name,
          "name": option.label,
          "required": field.mandatory == 1
        }
      }, [_vm._v("\n                                      " + _vm._s(option.name) + "\n                                    ")])
    })], 2)])])]) : _vm._e()])
  })], 2) : _vm._e()])])]), _vm._v(" "), (_vm.$route.name != 'bookings.create') ? _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("SuperConcierge")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "superconcierge-cleaning-fees"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.rentals.cleaning_fees")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.superconcierge_cleaning_fees),
      expression: "booking.superconcierge_cleaning_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "superconcierge-cleaning-fees",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.superconcierge_cleaning_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "superconcierge_cleaning_fees", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "superconcierge-linen-fees"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.rentals.linen_fees")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.superconcierge_linen_fees),
      expression: "booking.superconcierge_linen_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "superconcierge-linen-fees",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.superconcierge_linen_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "superconcierge_linen_fees", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "superconcierge-checkin-fees"
    }
  }, [_vm._v(_vm._s(_vm.$t("superconcierge.rentals.checkin_fees")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.booking.superconcierge_checkin_fees),
      expression: "booking.superconcierge_checkin_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "superconcierge-checkin-fees",
      "required": ""
    },
    domProps: {
      "value": (_vm.booking.superconcierge_checkin_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.booking, "superconcierge_checkin_fees", $event.target.value)
      }
    }
  })])])])])])]) : _vm._e()]), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.right && _vm.user.right.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 booking-form-inner"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 booking-form-inner"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner total-col clearfix text-uppercase"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('booking.detail.total')) + "\n                        "), _c('span', {
    staticClass: "total-value pull-right"
  }, [_vm._v(_vm._s(_vm.getPriceAmount(_vm.booking)) + " " + _vm._s(_vm.currency))])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'messages'),
      expression: "activeTab == 'messages'"
    }],
    staticClass: "row right-section message-page"
  }, [_c('div', {
    staticClass: "col-3 notifications-section"
  }, [_c('div', {
    staticClass: "col-12 title-section"
  }, [_c('div', {
    staticClass: "booking-details-notifications-header row d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "col-2"
  }, [_c('i', {
    staticClass: "far fa-bell notifications-bell"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "col-5"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.notifications')))])])]), _vm._v(" "), (_vm.notificationData && Object.getOwnPropertyNames(_vm.notificationData).length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-12 booking-details-notifications font"
  }, _vm._l((_vm.notificationData), function(notification, dispatchedJobId) {
    return _c('div', {
      staticClass: "booking-notifications-content d-flex justify-content-center align-items-center py-10"
    }, [_c('div', {
      staticClass: "col-2"
    }, [(new Date(notification.triggerTime) > new Date()) ? _c('i', {
      staticClass: "fa fa-clock-o sent-notification"
    }) : _vm._e(), _vm._v(" "), ((new Date(notification.triggerTime) < new Date()) && notification.status == 1) ? _c('i', {
      staticClass: "fa fa-envelope-open-o open-notification"
    }) : _vm._e(), _vm._v(" "), ((new Date(notification.triggerTime) < new Date()) && (notification.status == 0 || notification.status == 2)) ? _c('i', {
      staticClass: " fa fa-envelope-o open-notification"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      class: (new Date(notification.triggerTime) > new Date()) || (new Date(notification.triggerTime) < new Date() && notification.status == 0) ? 'font-weight-bold col-5' : 'col-5'
    }, [(notification.status === 0) ? _c('p', {
      staticClass: "text-danger font-weight-bold",
      attrs: {
        "data-toggle": "popover",
        "data-trigger": "manual",
        "title": notification.status === 0 && _vm.$t('booking.detail.failed_notification_reason'),
        "data-content": notification.response
      },
      on: {
        "mouseover": function($event) {
          _vm.showPopover($event, notification.status)
        },
        "mouseleave": function($event) {
          _vm.hidePopover($event, notification.status)
        }
      }
    }, [_vm._v(_vm._s(notification.title))]) : _vm._e(), _vm._v(" "), (notification.status !== 0) ? _c('p', {
      class: notification.status === 1 ? 'text-success font-weight-bold' : ''
    }, [_vm._v(_vm._s(notification.title))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("getWeekDayFromDateCalendar")(notification.triggerTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-3 p-l-0 pr-0 d-flex"
    }, [_c('img', {
      staticClass: "mr-15 cursor-pointer",
      attrs: {
        "src": "/static/assets/images/SuperHote_icons/eye.svg",
        "alt": "NO IMAGE"
      },
      on: {
        "click": function($event) {
          _vm.viewAutoAction(notification.dispatchedJobId)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "d-flex flex-column"
    }, [(new Date(notification.triggerTime) > new Date()) ? _c('a', {
      class: ("text-decoration-none cursor-pointer " + (notification.status === 0 ? 'mb-10 ' : '')),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.cancelNotification(notification.dispatchedJobId, dispatchedJobId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.cancel')))]) : _vm._e(), _vm._v(" "), (notification.status === 0) ? _c('a', {
      staticClass: "text-decoration-none cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.resendNotification(notification.dispatchedJobId)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.resend')))]) : _vm._e()])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6 message-content"
  }, [_c('div', {
    staticClass: "panel mb-0"
  }, [_c('div', {
    staticClass: "panel-body pb-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messagesLoading),
      expression: "!messagesLoading"
    }],
    staticClass: "page-main"
  }, [_c('div', {
    ref: "messages",
    staticClass: "app-message-chats"
  }, [_c('div', {
    staticClass: "empty-row title-section"
  }), _vm._v(" "), _c('div', {
    staticClass: "chats"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "chat",
      class: message.from == 'user' ? 'chat-left' : ''
    }, [(message.from == 'user') ? _c('div', {
      staticClass: "chat-avatar"
    }, [_c('a', {
      staticClass: "avatar",
      attrs: {
        "data-toggle": "tooltip",
        "href": "#",
        "data-placement": "left",
        "title": ""
      }
    }, [_c('img', {
      attrs: {
        "src": message.user && message.user.avatar ? message.user.avatar : 'static/material/global/portraits/avatar.png'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "message-info text-center"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (message.type == 'note' && message.from_auto_action),
        expression: "message.type == 'note' && message.from_auto_action"
      }],
      staticClass: "font-size-10"
    }, [_vm._v("Note Sms")])])]) : _vm._e(), _vm._v(" "), (message.from == 'guest') ? _c('div', {
      staticClass: "chat-avatar"
    }, [_c('a', {
      staticClass: "avatar",
      attrs: {
        "data-toggle": "tooltip",
        "href": "#",
        "data-placement": "right",
        "title": ""
      }
    }, [_c('img', {
      attrs: {
        "src": "static/material/global/portraits/avatar.png"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "chat-body"
    }, [_c('div', {
      class: (message.type == 'note') ? 'my-message-note chat-content' : (message.type == 'reminder') ? 'chat-content my-message-reminder' : (message.files && message.files.length > 0) ? 'chat-image-content' : 'chat-content'
    }, [_vm._l((message.files), function(file) {
      return (message.files && message.files.length > 0) ? _c('img', {
        attrs: {
          "src": file.url
        }
      }) : _vm._e()
    }), _vm._v(" "), (!message.files || message.files.length === 0) ? _c('pre', {
      domProps: {
        "innerHTML": _vm._s(message.text)
      }
    }) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "chat-date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("getWeekDayFromDateCalendar")(message.created_at)) + " - " + _vm._s(message.type == 'reminder' ? _vm.$t('booking.detail.reminder') : message.type))])])])
  }))]), _vm._v(" "), _c('form', {
    staticClass: "app-message-input pt-30",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send_message(_vm.message)
      }
    }
  }, [_c('div', {
    staticClass: "radio-cont"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagemail",
      "value": "mail"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "mail")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "mail")
      }
    }
  }), _vm._v(" "), (_vm.booking && _vm.booking['message_thread_id']) ? _c('label', {
    attrs: {
      "for": "messagemail"
    }
  }, [_vm._v("AIRBNB")]) : (_vm.booking && _vm.booking['booking_com_res_id']) ? _c('label', {
    attrs: {
      "for": "messagemail"
    }
  }, [_vm._v("Booking.com")]) : _c('label', {
    attrs: {
      "for": "messagemail"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.email')))])]), _vm._v(" "), (_vm.booking.rental && _vm.booking.rental.sms_integration == 1) ? _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagesms",
      "value": "sms"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "sms")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "sms")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagesms"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.sms')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagenote",
      "value": "note"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "note")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "note")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagenote"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.note')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary radio-whatsapp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "whatsapp",
      "value": "whatsApp"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "whatsApp")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "whatsApp")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "whatsapp"
    }
  }, [_c('i', {
    staticClass: "far fa-whatsapp"
  }), _vm._v("  WhatsApp")])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 d-flex cursor-pointer",
    on: {
      "click": function($event) {
        _vm.showTemplates()
      }
    }
  }, [_c('svg', {
    staticClass: "app-icon",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 60 60"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.9 46.4H7.8c-3.2 0-5.8-2.6-5.8-5.8V11.8C2 8.6 4.6 6 7.8 6h43.4c3.2 0 5.8 2.6 5.8 5.8v28.9c0 3.2-2.6 5.8-5.8 5.8H30.1l-11.2 7c-1.9 1.2-4.3.6-5.5-1.3-.4-.6-.6-1.4-.6-2.1v-3.7zm4.3 3l11.7-7.3h22.3c.8 0 1.4-.6 1.4-1.4V11.8c0-.8-.6-1.4-1.4-1.4H7.8c-.8 0-1.4.6-1.4 1.4v28.9c0 .8.6 1.4 1.4 1.4h9.4v7.3zm10-12.2c-2.4 1.5-5.5.7-7-1.7-.7-1.1-.9-2.5-.6-3.8l.6-2.5-1.9-1.7c-2.1-1.8-2.4-5-.6-7.1.9-1 2.1-1.6 3.4-1.7l2.5-.2 1-2.3c1.1-2.6 4-3.8 6.6-2.7 1.2.5 2.2 1.5 2.7 2.7l1 2.3 2.5.2c2.8.2 4.9 2.7 4.6 5.4-.1 1.3-.7 2.6-1.8 3.4l-1.9 1.7.6 2.5c.6 2.7-1 5.4-3.8 6.1-1.3.3-2.7.1-3.8-.6l-2.2-1.3-1.9 1.3zm2.2-6.4l4.4 2.7c.2.1.4.1.5.1.4-.1.6-.5.5-.9l-1.2-5 3.9-3.4c.1-.1.2-.3.3-.5 0-.4-.3-.7-.7-.8l-5.2-.4-2-4.8c-.1-.2-.2-.3-.4-.4-.4-.2-.8 0-.9.4l-2 4.8-5 .4c-.2 0-.4.1-.5.2-.3.3-.2.8.1 1l3.9 3.4-1.2 5c0 .2 0 .4.1.5.2.3.7.4 1 .2l4.4-2.5z"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "m-l-10 text-uppercase cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('message_templates.template')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-end"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reminderTime == 6),
      expression: "reminderTime == 6"
    }],
    staticClass: "col-7 m-t-5"
  }, [_c('span', [_c('next-date-picker', {
    staticClass: "datepicker",
    attrs: {
      "confirm": "",
      "type": "datetime",
      "lang": _vm.language,
      "not-before": new Date(),
      "clearable": true,
      "width": "100%",
      "input-class": "mx-input input-date",
      "time-picker-options": {
        start: '00:00',
        step: '01:00',
        end: '24:00'
      },
      "format": "MMM DD, YYYY, HH:mm a"
    },
    model: {
      value: (_vm.customDateSelected),
      callback: function($$v) {
        _vm.customDateSelected = $$v
      },
      expression: "customDateSelected"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reminderTime == 7 || _vm.reminderTime == 8 || _vm.reminderTime == 9 || _vm.reminderTime == 10),
      expression: "reminderTime == 7 || reminderTime == 8 || reminderTime == 9 || reminderTime == 10"
    }],
    staticClass: "col-5 before-after-time"
  }, [_c('div', {
    staticClass: "form-group detail-days form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beforeOrAfterDays),
      expression: "beforeOrAfterDays"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.beforeOrAfterDays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((200), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }))])]), _vm._v(" "), _c('div', {
    class: _vm.reminderTime == 7 || _vm.reminderTime == 8 || _vm.reminderTime == 9 || _vm.reminderTime == 10 ? 'col-7' : 'col-5'
  }, [_c('div', {
    staticClass: "radio-cont justify-content-end"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('div', {
    staticClass: "dropdown padding-none dropup"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.type),
      expression: "message.type"
    }],
    attrs: {
      "type": "radio",
      "id": "message-reminder",
      "value": "reminder",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.message.type, "reminder")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.message, "type", "reminder")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message-reminder"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.reminder')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right reminder-dropdown"
  }, [_c('ul', {
    staticClass: "reminder-list"
  }, [_c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 1 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.one_hour")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 2 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.two_hour")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 3 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_tomorrow")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 4 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_two_days")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 5 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(5)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.same_time_one_week")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 7 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.after_checking")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 8 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(8)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.after_checkout")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 9 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(9)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.before_checking")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 10 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(10)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.before_checkout")))]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    class: _vm.reminderTime == 6 ? 'list-selected' : '',
    on: {
      "click": function($event) {
        _vm.selectReminderTime(6)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("booking.detail.reminder_times.custom_time")))])])])])])])])]), _vm._v(" "), (_vm.booking.booking_com_res_id) ? _c('div', {
    staticClass: "m-t-10"
  }, [_c('div', {
    staticClass: "dropdown padding-none dropup cursor-pointer"
  }, [_c('div', {
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', [_vm._v("Tag Messages")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right reminder-dropdown"
  }, [_c('ul', {
    staticClass: "reminder-list"
  }, [_c('li', {
    staticClass: "reminder-list-item",
    on: {
      "click": function($event) {
        _vm.tagMessages('mark_read')
      }
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.isConversationMarkedAsUnRead ? _vm.$t('booking.detail.messages.mark_as_read') : _vm.$t('booking.detail.messages.mark_as_unread')) + "\n                                ")]), _vm._v(" "), _c('li', {
    staticClass: "reminder-list-item",
    on: {
      "click": function($event) {
        _vm.tagMessages('mark_no_reply')
      }
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.isConversationMarkedReply ? _vm.$t('booking.detail.messages.mark_as_no_reply') : _vm.$t('booking.detail.messages.remove_mark_as_no_reply')) + "\n                                ")])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-material"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.text),
      expression: "message.text"
    }],
    ref: "message-textarea",
    attrs: {
      "placeholder": _vm.$t('booking.detail.write_something')
    },
    domProps: {
      "value": (_vm.message.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "text", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-pure btn-default ",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.send')))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messagesLoading),
      expression: "messagesLoading"
    }],
    staticClass: "row loader-wrapper bookings-message-loading"
  }, [_c('div', {
    staticClass: "md-preloader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": "75",
      "width": "75",
      "viewbox": "0 0 75 75"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "37.5",
      "cy": "37.5",
      "r": "33.5",
      "stroke-width": "4",
      "stroke": "#D7092E"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-3 result-section"
  }, [_c('div', [_c('div', {
    staticClass: "col-12 title-section p-l-0 short-center"
  }, [_c('div', {
    staticClass: "booking_tle text-uppercase"
  }, [_c('i', {
    staticClass: "icon-rental-user"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "range-section"
  }, [_c('div', {
    staticClass: "short-center"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.status')))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.duration')))])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6 text-green"
  }, [_c('span', [_vm._v(_vm._s(_vm.getBookingStatusName(_vm.booking.status, _vm.booking.statusCode, _vm.booking.payment_is_done)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm._f("calculateNight")(_vm.booking.checking, _vm.booking.checkout)) + " " + _vm._s(_vm.$t('messages.index.nights')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "pt-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.check_in')))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.check_out')))])]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.date(_vm.booking.checking)) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.date(_vm.booking.checkout)))])])]), _vm._v(" "), _c('div', {
    staticClass: "pt-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.platform')))]), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.user.rights.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "col-6 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.total_price')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row font-weight-600 font-size-12"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.booking.channel ? _vm.booking.channel.name : ''))]), _vm._v(" "), ((_vm.user.is_team_member && _vm.user.rights && _vm.user.rights.booking_prices) || !_vm.user.is_team_member) ? _c('div', {
    staticClass: "col-6"
  }, [_vm._v(_vm._s(_vm.getPriceAmount(_vm.booking)) + " " + _vm._s(_vm.currency))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "center-section"
  }, [_c('div', {
    staticClass: "short-center name-image"
  }, [_c('i', {
    staticClass: "far fa-building"
  }), _vm._v(" "), _c('a', {
    staticClass: "text-uppercase color-pink font-weight-600 pl-2",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotoRentalDetails()
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.booking.rental && _vm.booking.rental.name))])]), _vm._v(" "), _c('div', {
    staticClass: "short-center pt-15"
  }, [_c('div', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.$t('messages.index.total_guests')))]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-600"
  }, [_vm._v(_vm._s(_vm.booking.nbr_adults + _vm.booking.nbr_children))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'payments' && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.right && _vm.user.right.booking_actions == 1))),
      expression: "activeTab == 'payments' && (!user.is_team_member || (user.is_team_member == 1 && user.right && user.right.booking_actions == 1))"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', [_c('div', [_c('div', {
    staticClass: "panel-body bg-white pl-0 pr-0"
  }, [_c('table', {
    staticClass: "table text-center payments-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.created')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.description')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.imported')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.status')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.payments.total')) + " ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.hostPayoutFee), function(payment, index) {
    return ((!payment.imported && payment.status == 1) ? payment.captured == 1 : true) ? _c('tr', {
      class: payment.stripe_account_id ? 'cursor-pointer' : '',
      on: {
        "click": function($event) {
          _vm.openPaymentPanel(payment)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatDate")(payment.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("truncate")(payment.description, 20)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.imported ? _vm.$t('payments.index.yes') : _vm.$t('payments.index.no')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.type))]), _vm._v(" "), _c('td', {
      class: payment.status ? 'payment-paid' : 'payment-pending',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return (function () {})($event)
        }
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (payment.paymentStatus),
        expression: "payment.paymentStatus"
      }],
      staticClass: "change-payment-status",
      attrs: {
        "name": "payment_status"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(payment, "paymentStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.changePaymentStatus(payment)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v(_vm._s(_vm.$t('payments.index.payment_status.paid')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v(_vm._s(_vm.$t('payments.index.payment_status.pending')))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((parseFloat(payment.amount.toFixed(2)) * payment.quantity) + " " + _vm.currency)) + " ")])]) : _vm._e()
  }))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'contract' && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.right && _vm.user.right.booking_actions == 1))),
      expression: "activeTab == 'contract' && (!user.is_team_member || (user.is_team_member == 1 && user.right && user.right.booking_actions == 1))"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invoices col-sm-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body bg-white"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "main-content contract-content",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "invoice_page contract-margin"
  }, [_c('div', {
    staticClass: "invoice_info clearfix"
  }, [_c('div', {
    staticClass: "info_left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_address"
  }, [_c('h5', [_c('strong', [_vm._v(" " + _vm._s(_vm.guest.first_name) + "   " + _vm._s(_vm.guest.last_name) + " ")])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.email')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.email))])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.phone')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.phone))])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.address')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.address) + " " + _vm._s(_vm.guest.city) + " " + _vm._s(_vm.guest.country))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_date clearfix"
  }, [_c('form', {
    attrs: {
      "action": "",
      "id": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.check_in')))]), _vm._v(" "), _c('div', {
    staticClass: "info_date_select"
  }, [_c('select', [(_vm.booking.checking) ? _c('option', [_vm._v(_vm._s(_vm.getShortWeekDay(_vm.booking.checking)))]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('form', [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.check_out')))]), _vm._v(" "), _c('div', {
    staticClass: "info_date_select"
  }, [_c('select', [(_vm.booking.checkout) ? _c('option', [_vm._v(_vm._s(_vm.getShortWeekDay(_vm.booking.checkout)))]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_date clearfix"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.status')) + "\n                                    "), (_vm.booking && _vm.booking.booking_contract && _vm.booking.booking_contract.id) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('booking.detail.signed')))]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('booking.detail.not_signed')))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.booking && _vm.booking.contract_last_seen) ? _c('div', {
    staticClass: "last-seen-date"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("booking.detail.invoices.last_seen")) + "  ")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.booking && _vm.booking.contract_last_seen ? _vm.booking.contract_last_seen : ''))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12 left-border"
  }, [_c('div', {
    staticClass: "info_right"
  }, [_c('div', {
    staticClass: "info_num"
  }, [_c('div', {
    staticClass: "signing-contract"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": '#/booking/' + _vm.booking.permalink + '/contract'
    }
  }, [_c('img', {
    staticClass: "signing-contract",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/marker2.svg",
      "alt": "signing-contract"
    }
  })])])])])])])])])])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'invoices' && (!_vm.user.is_team_member || (_vm.user.is_team_member == 1 && _vm.user.right && _vm.user.right.booking_actions == 1))),
      expression: "activeTab == 'invoices' && (!user.is_team_member || (user.is_team_member == 1 && user.right && user.right.booking_actions == 1))"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invoices col-sm-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body bg-white"
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('div', {
    staticClass: "main-content invoice-content",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "invoice_page invoice-margin"
  }, [_c('div', {
    staticClass: "invoice_info clearfix"
  }, [_c('div', {
    staticClass: "info_left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_address"
  }, [_c('h5', [_c('strong', [_vm._v(" " + _vm._s(_vm.guest.first_name) + "   " + _vm._s(_vm.guest.last_name) + " ")])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.email')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.email))])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.phone')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.phone))])]), _vm._v(" "), _c('h5', [_c('strong', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.address')) + " ")]), _c('span', [_vm._v(_vm._s(_vm.guest.address) + " " + _vm._s(_vm.guest.city) + " " + _vm._s(_vm.guest.country))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_date clearfix"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.check_in')))]), _vm._v(" "), _c('div', {
    staticClass: "info_date_select"
  }, [_c('select', [(_vm.booking.checking) ? _c('option', [_vm._v(_vm._s(_vm.getShortWeekDay(_vm.booking.checking)))]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('form', [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.check_out')))]), _vm._v(" "), _c('div', {
    staticClass: "info_date_select"
  }, [_c('select', [(_vm.booking.checkout) ? _c('option', [_vm._v(_vm._s(_vm.getShortWeekDay(_vm.booking.checkout)))]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_date clearfix"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.status')) + " "), _c('span', [_vm._v(_vm._s(_vm.booking.payment_is_done == 1 ? _vm.$t('booking.detail.paid') : _vm.$t('booking.detail.unpaid')))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-6 col-12"
  }, [_c('div', {
    staticClass: "info_right invoice-info"
  }, [_c('div', {
    staticClass: "info_num"
  }, [_c('div', {
    staticClass: "info_address"
  }, [_c('h5', [_c('strong', [_vm._v("#" + _vm._s(_vm.rental.id))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.rental.email) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.address) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.city) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.country ? _vm.rental.country.name : '') + " "), _c('br'), _vm._v(" " + _vm._s(_vm.rental.phone) + " "), _c('br')])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "invoice_details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.description')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.amount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.type')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.vat')) + " %")]), _vm._v(" "), _c('th', {
    staticClass: "line-total"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.line_total')))])])]), _vm._v(" "), _vm._l((_vm.invoices), function(invoice, index) {
    return _c('tbody', {
      staticStyle: {
        "display": "table-row-group"
      }
    }, [(!invoice.imported ? invoice.captured === 1 : true) ? _c('tr', [_c('td', [_c('div', {
      staticClass: "delete-invoice",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove_invoice_item(index, invoice.id)
        }
      }
    }, [_c('i', {
      staticClass: "icon md-close"
    })]), _vm._v(" "), _c('div', {
      staticClass: "invoice-rental"
    }, [_c('span', {
      staticClass: "tl"
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.description')) + " "), _c('i', {
      staticClass: "icon md-star",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invoices[index].description),
        expression: "invoices[index].description"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": ""
      },
      domProps: {
        "value": (_vm.invoices[index].description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.invoices[index], "description", $event.target.value)
        }
      }
    })])])])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tl"
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.amount')) + " "), _c('i', {
      staticClass: "icon md-star",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invoices[index].amount),
        expression: "invoices[index].amount"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "required": ""
      },
      domProps: {
        "value": (_vm.invoices[index].amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.invoices[index], "amount", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon"
    }, [_vm._v(_vm._s(_vm.currency))])])])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "type_select"
    }, [_c('form', [_c('div', {
      staticClass: "type_select_box"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invoices[index].type),
        expression: "invoices[index].type"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.invoices[index].type === 'schedule' || _vm.invoices[index].type === 'auto'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.invoices[index], "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "nights"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.nights')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "cleaning"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.cleaning_fees')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "taxes"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.city_taxes')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "other"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.other')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "hostFee"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.host_fee')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "service charge"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.service_charge')))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "promotion"
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.promotion')))]), _vm._v(" "), (_vm.invoices[index].type === 'schedule') ? _c('option', {
      attrs: {
        "value": "schedule"
      },
      domProps: {
        "selected": _vm.invoices[index].type === 'schedule'
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.schedule')))]) : _vm._e(), _vm._v(" "), (_vm.invoices[index].type === 'auto') ? _c('option', {
      attrs: {
        "value": "auto"
      },
      domProps: {
        "selected": _vm.invoices[index].type === 'auto'
      }
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.auto')))]) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "drop_arrow"
    })])])])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tl"
    }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.vat')) + " "), _c('i', {
      staticClass: "icon md-star",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.invoices[index].vat),
        expression: "invoices[index].vat"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "disabled": _vm.invoices[index].type === 'taxes' || _vm.invoices[index].type === 'service charge'
      },
      domProps: {
        "value": (_vm.invoices[index].vat)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.invoices[index], "vat", $event.target.value)
        }
      }
    })])])])])]), _vm._v(" "), _c('td', {
      staticClass: "total"
    }, [_c('span', {
      staticClass: "total_value"
    }, [_vm._v(" " + _vm._s((_vm.invoices[index].amount * _vm.invoices[index].quantity).toFixed(2)) + " " + _vm._s(_vm.currency))])])]) : _vm._e()])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "invoice_total"
  }, [_c('p', [_c('span', [_vm._v(" " + _vm._s(_vm.$t('booking.detail.invoices.invoice_total')) + " ")]), _vm._v(_vm._s(_vm.invoiceSum.toFixed(2)) + " " + _vm._s(_vm.currency))])])])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'events'),
      expression: "activeTab == 'events'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invoices col-sm-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "bookings-table-sizes row-link table table-responsive table-margin",
    attrs: {
      "id": "bookings-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "booking-id",
    on: {
      "click": function($event) {
        _vm.sortById = !_vm.sortById
      }
    }
  }, [_c('span', {
    attrs: {
      "id": "booking-id-td"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.id')))]), _c('span', {
    class: [_vm.sortById ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    staticClass: "booking-rental",
    on: {
      "click": function($event) {
        _vm.sortByRental = !_vm.sortByRental
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.rental')) + " "), _c('span', {
    class: [_vm.sortByRental ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sortByGuestName = !_vm.sortByGuestName
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.guest')) + " "), _c('span', {
    class: [_vm.sortByGuestName ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sortByCheckOut = !_vm.sortByCheckOut
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.created_at')) + " "), _c('span', {
    class: [_vm.sortByCheckOut ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    staticClass: "booking-nights",
    on: {
      "click": function($event) {
        _vm.sortByNights = !_vm.sortByNights
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.nights')) + " "), _c('span', {
    class: [_vm.sortByNights ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    staticClass: "booking-people",
    on: {
      "click": function($event) {
        _vm.sortByPeople = !_vm.sortByPeople
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.index.people')) + " "), _c('span', {
    class: [_vm.sortByPeople ? 'sorting' : 'sorting_asc']
  })]), _vm._v(" "), _c('th', {
    staticClass: "booking-action",
    on: {
      "click": function($event) {
        _vm.sortByStatus = !_vm.sortByStatus
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.manage_type')) + " "), _c('span', {
    class: [_vm.sortByStatus ? 'sorting' : 'sorting_asc']
  })])])]), _vm._v(" "), _c('tbody', [_c('span', {
    attrs: {
      "tod": _vm.varToday = new Date()
    }
  }), _vm._v(" "), _vm._l((_vm.bookingEvents), function(bookingEvent) {
    return _c('tr', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showChecklistModal(bookingEvent)
        }
      }
    }, [_c('td', {
      staticClass: "booking-id booking-detail"
    }, [_c('div', {
      attrs: {
        "id": "booking-id-td"
      }
    }, [_vm._v(_vm._s(bookingEvent.id))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-rental booking-detail"
    }, [_c('div', [_vm._v(_vm._s(_vm.booking.rental && _vm.booking.rental.name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-guest booking-detail"
    }, [_c('div', [_vm._v(_vm._s(_vm.guest.first_name + ' ' + _vm.guest.last_name))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-csubmittion-time booking-detail"
    }, [_c('div', [_vm._v(_vm._s(bookingEvent.created_at))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-nights booking-detail"
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" " + _vm._s(_vm._f("calculateNight")(_vm.booking.checking, _vm.booking.checkout)))])]), _vm._v(" "), _c('td', {
      staticClass: "booking-people booking-detail"
    }, [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(_vm.booking.nbr_adults) + " ")])]), _vm._v(" "), _c('td', {
      staticClass: "booking-action"
    }, [_c('div', [_c('span', {
      staticClass: "status-booking confirmed"
    }, [_vm._v(_vm._s(bookingEvent.checklist_group_type.name))])])])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == 'forms'),
      expression: "activeTab == 'forms'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "invoices col-sm-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.forms.length == 0) ? _c('div', [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.forms.no_forms_for_this_rental")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openSetupRentalFormTab(_vm.booking.rental.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.setup")))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forms.length > 0),
      expression: "forms.length > 0"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row adding-form form-margin"
  }, _vm._l((_vm.forms), function(form) {
    return _c('div', {
      staticClass: "col-4 p-0 m-0"
    }, [_c('div', {
      staticClass: "content form-item"
    }, [_c('div', {
      staticClass: "row m-0 h-100"
    }, [_c('div', {
      staticClass: "col-2 p-0 h-100"
    }, [_c('div', {
      staticClass: "icon h-100"
    }, [_c('img', {
      attrs: {
        "src": "/static/assets/images/icons2/gray.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-9"
    }, [_c('div', {
      staticClass: "subject h-100"
    }, [_c('div', {
      staticClass: "descr title"
    }, [_vm._v(_vm._s(form.title))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "descr edit btn10",
      attrs: {
        "data-clipboard-text": _vm.location.protocol + '//' + 'superhote.com' + '/applink/booking/' + _vm.booking.permalink + '/' + form.type.name
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.forms.copy_form_link")))])]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "descr edit btn10"
    }, [_c('a', {
      staticClass: "descr edit text-decoration-none",
      attrs: {
        "target": "_blank",
        "href": _vm.location.protocol + '//' + 'superhote.com' + '/applink/booking/' + _vm.booking.permalink + '/' + form.type.name
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.forms.view_form_link")))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "descr edit btn10"
    }, [_c('a', {
      staticClass: "descr edit text-decoration-none",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.$refs.sendFormModal.open_send_form_modal(_vm.booking, _vm.guest, form)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("rentals.detail.forms.send_form")))])])])])])])])])])
  }))])])])])])])]), _vm._v(" "), _c('v-resources', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'resources'),
      expression: "activeTab === 'resources'"
    }],
    attrs: {
      "resources": _vm.booking.resources
    },
    on: {
      "getResources": _vm.getResources
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'event-logger'),
      expression: "activeTab === 'event-logger'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("logs.title")))]), _vm._v(" "), _c('div', {
    staticClass: "pb-2"
  }, _vm._l((Object.keys(_vm.logs)), function(logDate) {
    return _c('div', [_c('h3', {
      staticClass: "text-left mb-2 font-weight-bold",
      staticStyle: {
        "font-size": "14px",
        "color": "#57668b"
      }
    }, [_vm._v("\n                      " + _vm._s(logDate) + "\n                    ")]), _vm._v(" "), _vm._l((_vm.logs[logDate]), function(log) {
      return _c('div', {
        staticClass: "d-block"
      }, [_c('b', {
        attrs: {
          "title": log.event_at
        }
      }, [_vm._v(_vm._s(log.hour_at) + " - ")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(log.value)
        }
      })])
    }), _vm._v(" "), (!_vm.logs[logDate].length) ? _c('div', {
      staticClass: "d-block"
    }, [_c('span', {
      staticClass: "font-italic",
      staticStyle: {
        "color": "#b7b7b7"
      }
    }, [_vm._v(_vm._s(_vm.$t("logs.nologs")))])]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticStyle: {
        "width": "15px",
        "margin-left": "0",
        "color": "#c7cce5"
      }
    })], 2)
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "additional-payment-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save_payment(_vm.payment)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.captured == 1 ? _vm.$t('payments.index.modal_title_payment') : _vm.$t('payments.index.modal_title_deposit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#additional-payment-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n                    " + _vm._s(err[0]) + "\n                  ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n                    " + _vm._s(_vm.error) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v(_vm._s(_vm.success))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "amount"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.amount")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.amount),
      expression: "payment.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "amount",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.payment.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "apartment"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.type")))]), _vm._v(" "), _c('div', {
    staticClass: "type_select"
  }, [_c('form', [_c('div', {
    staticClass: "type_select_box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.type),
      expression: "payment.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "apartment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.payment, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nights"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.nights')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cleaning"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.cleaning_fees')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "taxes"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.city_taxes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.other')))])]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.customer_email")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.customer_email),
      expression: "payment.customer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.customer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "customer_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("input.booking")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.booking_id),
      expression: "payment.booking_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment.booking_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "booking_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-stripe-account"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('input.select_stripe_account')) + "\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.stripe_account_id),
      expression: "payment.stripe_account_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-stripe-account",
      "name": "rentals-stripe-account"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.payment, "stripe_account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.stripe_accounts), function(stripe_account) {
    return _c('option', {
      domProps: {
        "value": stripe_account.id
      }
    }, [_vm._v(_vm._s(stripe_account.name))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "title"
    }
  }, [_vm._v(_vm._s(_vm.$t("payments.index.titleModal")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.title),
      expression: "payment.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "title",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "description"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.description")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.description),
      expression: "payment.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "description",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "description", $event.target.value)
      }
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "id": "additional-modal-close",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("button.create")))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallLoading),
      expression: "!smallLoading"
    }],
    staticClass: "btn btn-primary waves-effect waves-classic btn-create-send",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createAndSend(_vm.payment)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.create_and_send")))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "make-payment-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "id": "make-direct-payment"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.chargePayment($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.captured == 1 ? _vm.$t('button.make_payment') : _vm.$t('button.make_deposit')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#make-payment-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n                  " + _vm._s(err[0]) + "\n                ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v(_vm._s(_vm.success))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "pay-amount"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.amount")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.amount),
      expression: "payment.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pay-amount",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.payment.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "amount", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "pay-apartment"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.type")))]), _vm._v(" "), _c('div', {
    staticClass: "type_select"
  }, [_c('form', [_c('div', {
    staticClass: "type_select_box"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.type),
      expression: "payment.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pay-apartment"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.payment, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nights"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.nights')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cleaning"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.cleaning_fees')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "taxes"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.city_taxes')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v(_vm._s(_vm.$t('input.other')))])]), _vm._v(" "), _c('i', {
    staticClass: "drop_arrow"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "guest-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.customer_email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.customer_email),
      expression: "payment.customer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "guest-email",
      "disabled": "true",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.customer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "customer_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t("input.booking")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.booking_id),
      expression: "payment.booking_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.payment.booking_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "booking_id", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "charge-title"
    }
  }, [_vm._v(_vm._s(_vm.$t("payments.index.titleModal")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.title),
      expression: "payment.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "charge-title",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "stripe-account"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('input.select_stripe_account')) + "\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.stripe_account_id),
      expression: "payment.stripe_account_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "stripe-account",
      "name": "rentals-stripe-account"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.payment, "stripe_account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.stripe_accounts), function(stripe_account) {
    return _c('option', {
      domProps: {
        "value": stripe_account.id
      }
    }, [_vm._v(_vm._s(stripe_account.name))])
  }))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.booking.customer_id),
      expression: "booking.customer_id"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 m-b-20"
  }, [_c('div', {
    staticClass: "form-group form-material checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useCustomerId),
      expression: "useCustomerId"
    }],
    attrs: {
      "type": "checkbox",
      "id": "use-customer-id"
    },
    domProps: {
      "checked": Array.isArray(_vm.useCustomerId) ? _vm._i(_vm.useCustomerId, null) > -1 : (_vm.useCustomerId)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useCustomerId,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useCustomerId = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useCustomerId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useCustomerId = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "use-customer-id"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.use_customer_id')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.useCustomerId && !_vm.smallLoading),
      expression: "!useCustomerId && !smallLoading"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material form-control"
  }, [_c('div', {
    attrs: {
      "id": "charge-card-number"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material form-control"
  }, [_c('div', {
    attrs: {
      "id": "charge-card-expiration-data"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material form-control"
  }, [_c('div', {
    attrs: {
      "id": "charge-card-cvc"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "pay-description"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.description")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment.description),
      expression: "payment.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "pay-description",
      "required": ""
    },
    domProps: {
      "value": (_vm.payment.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.payment, "description", $event.target.value)
      }
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading && !_vm.useCustomerId,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "id": "make-payment-modal-close",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallLoading),
      expression: "!smallLoading"
    }],
    staticClass: "btn btn-primary waves-effect waves-classic btn-create-send",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.captured == 1 ? _vm.$t('button.make_payment') : _vm.$t('button.make_deposit')))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "send-invoice-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send_invoice(_vm.sendInvoice)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.invoices.send_invoice_modal.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-invoice-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-invoice-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendInvoice.email),
      expression: "sendInvoice.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "send-invoice-email",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendInvoice.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendInvoice, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material m-b-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-language"
    }
  }, [_vm._v("\n                         " + _vm._s(_vm.$t("input.language")) + "\n                       ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendInvoice.language),
      expression: "sendInvoice.language"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language",
      "id": "invoice-language"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sendInvoice, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getTemplateByLang(_vm.sendInvoice.language, 'invoice', 'Send invoice')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.english")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.french")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.spanish")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.portugal")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-invoice-subject"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.subject")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendInvoice.subject),
      expression: "sendInvoice.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "send-invoice-subject",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendInvoice.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendInvoice, "subject", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.message")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendInvoice.message),
      expression: "sendInvoice.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "name": "message",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendInvoice.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendInvoice, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-invoice-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send")))])], 1)])])])]), _vm._v(" "), _c('v-send-form-modal', {
    ref: "sendFormModal",
    attrs: {
      "shortCodes": _vm.shortCodes,
      "invoiceSum": _vm.invoiceSum,
      "bookingEvents": _vm.bookingEvents
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade select-date-modal",
    attrs: {
      "id": "checklist-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-lg"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 vl-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.check_list')) + " : " + _vm._s(_vm.selectedBookingEvent.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#checklist-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row info-content"
  }, [_c('div', {
    staticClass: "col-6 incident info pt-15"
  }, [_c('div', {
    staticClass: "client-info m-t-15"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 line"
  }, [_c('h2', {
    staticClass: "font-size-20 font-weight-bold client-title mb-10"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.client_information')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-7"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-rental-user"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.guest.first_name + ' ' + _vm.guest.last_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "content d-flex"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/phone-wave.svg",
      "alt": "user"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.guest.phone))])])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row email-border"
  }, [_c('div', {
    staticClass: "col-12 m-t-15"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/envelop2.svg",
      "alt": "user",
      "width": "16"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.guest.email))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 line"
  }, [_c('h4', {
    staticClass: "font-size-20 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.selectedBookingEvent.checklist_group_type.name) + " : "), _c('span', {
    staticClass: "descr-span"
  }, [_vm._v(_vm._s(_vm.selectedBookingEvent.description))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "col-12 "
  }, [_c('h2', {
    staticClass: "font-size-20 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.selectedBookingEvent.created_at, 'DD MMMM YYYY')))])])]), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.selectedBookingEvent.booking_group_checklists && _vm.selectedBookingEvent.booking_group_checklists.length > 0) ? _c('div', {
    staticClass: "check-list"
  }, [_c('h3', {
    staticClass: "font-size-20 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.checklist')))]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.selectedBookingEvent.booking_group_checklists), function(checklist) {
    return _c('li', {
      class: checklist.status ? 'line-through active' : 'not-checked'
    }, [_vm._v(_vm._s(checklist.name))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6 check-list hotel-info pl-0 pt-15"
  }, [_c('h3', {
    staticClass: "font-size-20 font-weight-bold mb-10 m-t-15"
  }, [_vm._v(_vm._s(_vm.booking.rental && _vm.booking.rental.name))]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-6 check"
  }, [_c('img', {
    staticClass: "mr-5",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/redo.svg",
      "alt": "check in",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('booking.detail.events.checkin')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v(" " + _vm._s(_vm.booking.checking) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 check"
  }, [_c('img', {
    staticClass: "mr-5",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/undo.svg",
      "alt": "check out",
      "width": "16"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('booking.detail.events.checkout')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("  " + _vm._s(_vm.booking.checkout))])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "row memeber-info m-0 m-t-15"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('i', {
    staticClass: "icon-rental-user mr-5"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.nbr_adults) + " " + _vm._s(_vm.$t('booking.detail.events.adults')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "mr-5",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/baby-girl.svg",
      "alt": "",
      "width": "22"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.booking.nbr_children) + " " + _vm._s(_vm.$t('booking.detail.events.children')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('i', {
    staticClass: "icon-rental-moon mr-5"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("calculateNight")(_vm.booking.checking, _vm.booking.checkout)) + " " + _vm._s(_vm.$t('booking.detail.events.night')))])])]), _vm._v(" "), _c('div', {
    staticClass: "hotel-photos details"
  }, [_c('h3', {
    staticClass: "font-size-20 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.photos')))]), _vm._v(" "), (_vm.selectedBookingEvent.images && _vm.selectedBookingEvent.images.length > 0) ? _c('div', {
    staticClass: "row m-0"
  }, _vm._l((_vm.selectedBookingEvent.images), function(image) {
    return _c('div', {
      staticClass: "col-4"
    }, [_c('div', {
      staticClass: "image-content"
    }, [_c('img', {
      attrs: {
        "src": image.name,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.showImageModal(image)
        }
      }
    })])])
  })) : _c('div', {
    staticClass: "m-t-15"
  }, [_c('div', {
    staticClass: "image-empty"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "hotel-videos details"
  }, [_c('h3', {
    staticClass: "font-size-20 font-weight-bold mb-5"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.videos')))]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, _vm._l((_vm.selectedBookingEvent.videos), function(video) {
    return _c('div', {
      staticClass: "col-xl-5 col-lg-7"
    }, [_c('checklist-video', {
      attrs: {
        "video": video
      }
    })], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-11 m-auto comments"
  }, [_c('h3', {
    staticClass: "font-size-20 font-weight-bold mb-15 p-0"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.events.comments')))]), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [_vm._v(_vm._s(_vm.selectedBookingEvent.description))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer p-0"
  })])])]), _vm._v(" "), _c('ViewCheckListMultimedia', {
    attrs: {
      "file": _vm.multimediaItem
    },
    on: {
      "closeImageModal": _vm.closeImageModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "send-contract-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send_contract(_vm.sendContract)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.contract.send_contract_modal.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-contract-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-contract-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendContract.email),
      expression: "sendContract.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "send-contract-email",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendContract.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendContract, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material m-b-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "contract-language"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("input.language")) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendContract.language),
      expression: "sendContract.language"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language",
      "id": "contract-language"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sendContract, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getTemplateByLang(_vm.sendContract.language, 'contract', 'Send contract')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.english")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.french")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.spanish")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.portugal")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-contract-subject"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.subject")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendContract.subject),
      expression: "sendContract.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "send-contract-subject",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendContract.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendContract, "subject", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.message")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendContract.message),
      expression: "sendContract.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "name": "message",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendContract.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendContract, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-contract-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send")))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "charge-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('h4', {
    staticClass: "modal-title text-center"
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.are_you_sure_delete_charge')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delete_invoice(_vm.selectedInvoiceId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.delete")))]), _vm._v(" "), _c('button', {
    staticClass: "btn  waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close_invoice_modal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n              ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templateDetails),
      expression: "templateDetails"
    }],
    staticClass: "calendar-month-view"
  }, [_c('div', {
    staticClass: "panel messages-panel panel-white left"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.isTemplateDeleting
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTemplateDeleting),
      expression: "!isTemplateDeleting"
    }],
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('h2', {
    staticClass: "tle_p head-messages"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('message_templates.title')) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('span', {
    staticClass: "cross_icon font-size-30",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeTemplates()
      }
    }
  }, [_vm._v("x")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pannel_details"
  }, [_c('div', {
    staticClass: "message-templates"
  }, [_c('div', {
    staticClass: "row m-t-25"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "radio-cont"
  }, [_c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTemplateType),
      expression: "showTemplateType"
    }],
    attrs: {
      "type": "radio",
      "id": "general-templates",
      "value": "notification"
    },
    domProps: {
      "checked": _vm._q(_vm.showTemplateType, "notification")
    },
    on: {
      "change": function($event) {
        _vm.showTemplateType = "notification"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "general-templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('message_templates.notification')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified template-info",
    attrs: {
      "title": _vm.$t('booking.detail.notification_template_info')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showTemplateType),
      expression: "showTemplateType"
    }],
    attrs: {
      "type": "radio",
      "id": "user-templates",
      "value": "general"
    },
    domProps: {
      "checked": _vm._q(_vm.showTemplateType, "general")
    },
    on: {
      "change": function($event) {
        _vm.showTemplateType = "general"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user-templates"
    }
  }, [_vm._v(_vm._s(_vm.$t('message_templates.my_templates')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle fa-specified template-info",
    attrs: {
      "title": _vm.$t('booking.detail.general_template_info')
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newTemplateOpen && _vm.showTemplateType !== 'notification'),
      expression: "newTemplateOpen && showTemplateType !== 'notification'"
    }],
    staticClass: "row p-side-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "m-t-15",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.messageTemplate.id ? _vm.updateTemplate() : _vm.createTemplate()
      }
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "template-name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTemplate.name),
      expression: "messageTemplate.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "template-name",
      "required": ""
    },
    domProps: {
      "value": (_vm.messageTemplate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageTemplate, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group mb-20"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('message_templates.message')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-content-inner mb-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messageTemplate.body),
      expression: "messageTemplate.body"
    }],
    staticClass: "form-control",
    attrs: {
      "cols": "30",
      "rows": "3",
      "required": "",
      "id": "message-template-content"
    },
    domProps: {
      "value": (_vm.messageTemplate.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.messageTemplate, "body", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cursor-pointer open-shortcodes-button-msg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openShortcodeListModal('#shortcode-list-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("automation.index.modal.show_shortcode_list")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [(!_vm.messageTemplate.id) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelNewTemplateAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.saveTemplateDisabled
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])]), _vm._v(" "), _c('VShortCodeListModal', {
    attrs: {
      "selectedShortCode": _vm.selectedShortCode,
      "shortCodeName": _vm.shortCodeName
    },
    on: {
      "insertShortcodeToText": _vm.insertShortcodeToText,
      "closeAndOpenModals": _vm.closeAndOpenModals,
      "changeSelectedShortCode": _vm.changeSelectedShortCode
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-15"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.templateLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateType === 'notification'),
      expression: "showTemplateType === 'notification'"
    }]
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('div', {
      staticClass: "template-container m-t-15",
      on: {
        "click": function($event) {
          _vm.openBody(index, 'notification', $event)
        }
      }
    }, [_c('div', {
      staticClass: "template",
      class: notification.body_open ? 'template-body-open box' : ''
    }, [_c('p', {
      staticClass: "d-inline-block template-name"
    }, [_vm._v(_vm._s(notification.title))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.insertBody(index, 'notification', _vm.booking.id)
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t("button.insert")))])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (notification.body_open),
        expression: "notification.body_open"
      }],
      staticClass: "template template-body-open body"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(notification.message)
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateType === 'general'),
      expression: "showTemplateType === 'general'"
    }]
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newTemplateOpen),
      expression: "!newTemplateOpen"
    }],
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.newTemplateOpen = !_vm.newTemplateOpen
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.add")))]), _vm._v(" "), _vm._l((_vm.userTemplates), function(template, index) {
    return _c('div', {
      staticClass: "template-container m-t-15",
      on: {
        "click": function($event) {
          _vm.openBody(index, 'user', $event)
        }
      }
    }, [_c('div', {
      staticClass: "template",
      class: template.body_open ? 'template-body-open box' : ''
    }, [_c('p', {
      staticClass: "d-inline-block template-name"
    }, [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-primary waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.insertBody(index, 'user', _vm.booking.id)
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t("button.insert")))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-edit waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editTemplate(template.id, index, 'template', $event)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-delete waves-effect waves-classic btn-save",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteTemplate(template.id, index, 'template', $event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (template.body_open),
        expression: "template.body_open"
      }],
      staticClass: "template template-body-open body"
    }, [_c('pre', {
      domProps: {
        "innerHTML": _vm._s(template.body)
      }
    })])])
  })], 2)], 1)])])])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentDetails),
      expression: "paymentDetails"
    }],
    staticClass: "payment-right-menu"
  }, [_c('div', {
    staticClass: "panel panel-white left"
  }, [_c('div', {
    staticClass: "pannel_sec"
  }, [_c('div', {
    staticClass: "cross_icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closePaymentDetail()
      }
    }
  }, [_vm._v(" x ")]), _vm._v(" "), _c('div', {
    staticClass: "right-menu-header"
  }, [_c('div', {
    staticClass: "pannel_details"
  }, [_c('span', {
    class: _vm.paymentItem.status ? 'status-payment confirmed' : 'status-payment'
  }, [_vm._v("\n                    " + _vm._s(_vm.paymentItem.status ? _vm.$t('payments.index.payment_status.paid') : _vm.$t('payments.index.payment_status.pending')) + "\n                  ")]), _vm._v(" "), _c('h5', {
    staticClass: "right-menu-title"
  }, [_vm._v(_vm._s(_vm.paymentItem.title) + " "), _c('span', {
    staticClass: "hint-text"
  }, [_vm._v("(# " + _vm._s(_vm.paymentItem.id) + ")")])]), _vm._v(" "), (_vm.paymentItem.description) ? _c('p', {
    staticClass: "description"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('input.description')) + ":")]), _vm._v(" " + _vm._s(_vm.paymentItem.description))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "permalink-p"
  }, [_c('span', {
    attrs: {
      "id": "permalink"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.permalinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.permalinkUrl))])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('input.amount')))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(((_vm.paymentItem.amount) + " " + _vm.currency)))])])]), _vm._v(" "), _c('td', [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('input.deposit')))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(!_vm.paymentItem.captured ? _vm.$t('payments.index.yes') : _vm.$t('payments.index.no')))])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('input.email')))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.paymentItem.customer_email))])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('payments.index.history')))]), _vm._v(" "), _vm._l((_vm.paymentItem.histories), function(history) {
    return _c('p', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(_vm.paymentHistoryFilter(history.created_at)) + " - " + _vm._s(_vm.getPaymentHistoryActionName(history.action)))])
  }), _vm._v(" "), (_vm.paymentItem && _vm.paymentItem.histories && _vm.paymentItem.histories.length == 0) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("N/A")]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.paymentItem.captured) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('payments.index.paid_on')))]), _vm._v(" "), (_vm.paymentItem.paid_date) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.paymentItem.paid_date, 'DD MMMM YYYY hh:mm:ss')))]) : _vm._e(), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("N/A")]) : _vm._e()])])]) : _c('tr', [_c('td', [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('payments.index.paid_on')))]), _vm._v(" "), (_vm.paymentItem.paid_date) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm._f("changeDateFormat")(_vm.paymentItem.paid_date, 'DD MMMM YYYY hh:mm:ss')))]) : _vm._e(), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('p', {
    staticClass: "no-margin"
  }, [_vm._v("N/A")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_vm._v(_vm._s(_vm.$t('input.auto_renew')))]), _vm._v(" "), _c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.paymentItem.auto_renew ? _vm.$t("button.yes") : _vm.$t("button.no")))])])])]), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold btn8"
  }, [_c('a', {
    staticClass: "view-payment",
    attrs: {
      "href": _vm.permalinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('payments.index.view_payment')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right mr-30 semi-bold"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold btn8",
    attrs: {
      "data-clipboard-text": _vm.permalinkUrl
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('payments.index.copy_permalink')) + "\n                      "), _c('span', {
    staticClass: "pull-right mr-30 semi-bold"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('tr', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openSendPaymentModal(_vm.paymentItem)
      }
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payments.index.send_payment')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right mr-30 semi-bold"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.paymentItem.status) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.redirectToPaymentDetails(_vm.paymentItem.id)
      }
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payments.index.transactions_list')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right mr-30 semi-bold"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])]) : _vm._e(), _vm._v(" "), (!_vm.paymentItem.paid_date) ? _c('tr', {
    on: {
      "click": function($event) {
        _vm.openCancelPaymentModal(_vm.paymentItem.id)
      }
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', [_c('h5', {
    staticClass: "font-montserrat all-caps small no-margin hint-text bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payments.index.cancel_payment')))]), _vm._v(" "), _c('span', {
    staticClass: "pull-right mr-30 semi-bold"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "send-payment-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendPaymentEmailOrSms(_vm.sendPayment)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('payments.index.send_payment_modal.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-payment-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material m-b-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-payment-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.type")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.type),
      expression: "sendPayment.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagemail",
      "value": "mail"
    },
    domProps: {
      "checked": _vm._q(_vm.sendPayment.type, "mail")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.sendPayment, "type", "mail")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagemail"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.email')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-inline radio-primary "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.type),
      expression: "sendPayment.type"
    }],
    attrs: {
      "type": "radio",
      "id": "messagesms",
      "value": "sms"
    },
    domProps: {
      "checked": _vm._q(_vm.sendPayment.type, "sms")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.sendPayment, "type", "sms")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "messagesms"
    }
  }, [_vm._v(_vm._s(_vm.$t('booking.detail.sms')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material m-b-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "language"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.language")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.language),
      expression: "sendPayment.language"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sendPayment, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getTemplateByLang(_vm.sendPayment.language, 'payment', 'Send payment')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.english")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.french")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.spanish")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.message_templates_section.portugal")))])])])])]), _vm._v(" "), (_vm.sendPayment.type == 'mail') ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-payment-email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.email),
      expression: "sendPayment.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "send-payment-email",
      "name": "send-payment-email",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendPayment.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendPayment, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-payment-subject"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.subject")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.subject),
      expression: "sendPayment.subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "send-payment-subject",
      "name": "send-payment-subject",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendPayment.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendPayment, "subject", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.sendPayment.type == 'sms') ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "send-payment-phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.phone")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.phone),
      expression: "sendPayment.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "send-payment-phone",
      "name": "send-payment-phone",
      "placeholder": _vm.$t('booking.detail.payments.payment_message_phone'),
      "required": ""
    },
    domProps: {
      "value": (_vm.sendPayment.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendPayment, "phone", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.message")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendPayment.message),
      expression: "sendPayment.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "name": "message",
      "rows": "5",
      "required": ""
    },
    domProps: {
      "value": (_vm.sendPayment.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendPayment, "message", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#send-payment-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "disabled": _vm.smallLoading,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.send")))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "cancel-payment-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.cancelPayment(_vm.cancelPaymentId)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("payments.index.cancel_payment_sure_question")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#cancel-payment-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "disabled": _vm.smallLoading,
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#cancel-payment-modal')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.cancel")) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.smallLoading
    }
  }, [_vm._v(_vm._s(_vm.$t("payments.index.cancel_payment")))])])])])])]), _vm._v(" "), _c('NotificationContent', {
    attrs: {
      "autoActionContent": _vm.autoActionContent,
      "notificationLoading": _vm.notificationLoading
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7314d376"}!./src/app/pages/bookings/details/details.html
// module id = 1417
// module chunks = 0